import React from 'react'
import { QRCodeCanvas } from 'qrcode.react'

const QRCode = ({value}) => {

  return (
    <QRCodeCanvas
          value={value}
          title={value}
          size={128}
          bgColor={"#ffffff"}
          fgColor={"#000000"}
          level={"L"}
          marginSize={0}
        />
  )
}

export default QRCode